"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IMPORT_ENTITY_FILENAME = void 0;
exports.IMPORT_ENTITY_FILENAME = {
    PRODUCT: 'Product_Import_Template - Products.csv',
};
//# sourceMappingURL=importEntity.js.map